import { createReducer } from '@reduxjs/toolkit';
import type { IIstProduct, IProduct, IPowerOfAttorney } from '../../api/domain';
import type { IAddress, ICommunicationEntries, IEBankingContract, IIstKarte } from '../../api/domain/finnova';
import type { FinnovaCodeTable } from '../../api/domain/finnova/code-table';
import {
    fetchAddresses,
    fetchAddressesSuccess,
    fetchCardProductsSuccess,
    fetchCodesSuccess,
    fetchCommunicationEntries,
    fetchCommunicationEntriesSuccess,
    fetchEBankingContracts,
    fetchEBankingContractsSuccess,
    fetchIstCards,
    fetchIstCardsFailure,
    fetchIstCardsSuccess,
    fetchIstProducts,
    fetchIstProductsFailure,
    fetchIstProductsSuccess,
    fetchKannProducts,
    fetchKannProductsFailure,
    fetchKannProductsSuccess,
    fetchPowerOfAttorney,
    fetchPowerOfAttorneySuccess,
    fetchSollProducts,
    fetchSollProductsFailure,
    fetchSollProductsSuccess,
} from './finnova-api-actions';

interface IFinnovaApiState {
    kannProducts?: IProduct[];
    sollProducts?: IProduct[];
    istProducts?: IIstProduct[];
    istCards?: IIstKarte[];
    cardProducts?: IProduct[];
    eBankingContracts?: IEBankingContract[];
    powerOfAttorneys?: IPowerOfAttorney[];
    addresses?: IAddress[];
    communicationEntries?: ICommunicationEntries;
    finnovaCodeTable: FinnovaCodeTable;
}
export type { IFinnovaApiState };

export const initialState: IFinnovaApiState = {
    finnovaCodeTable: {},
};

export const finnovaApiReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(fetchCodesSuccess, (state, { payload: { columnName, codes } }) => {
            state.finnovaCodeTable[columnName] = codes;
        })
        .addCase(fetchKannProducts, (state) => {
            state.kannProducts = undefined;
        })
        .addCase(fetchKannProductsSuccess, (state, { payload: kannProducts }) => {
            state.kannProducts = kannProducts;
        })
        .addCase(fetchKannProductsFailure, (state) => {
            state.kannProducts = [];
        })
        .addCase(fetchIstProducts, (state) => {
            state.istProducts = undefined;
        })
        .addCase(fetchIstProductsSuccess, (state, { payload: istProducts }) => {
            state.istProducts = istProducts;
        })
        .addCase(fetchIstProductsFailure, (state) => {
            state.istProducts = [];
        })
        .addCase(fetchSollProducts, (state) => {
            state.sollProducts = undefined;
        })
        .addCase(fetchSollProductsSuccess, (state, { payload: sollProducts }) => {
            state.sollProducts = sollProducts;
        })
        .addCase(fetchSollProductsFailure, (state) => {
            state.sollProducts = [];
        })
        .addCase(fetchCardProductsSuccess, (state, { payload: cardProducts }) => {
            state.cardProducts = cardProducts;
        })
        .addCase(fetchIstCards, (state) => {
            state.istCards = undefined;
        })
        .addCase(fetchIstCardsSuccess, (state, { payload: istCards }) => {
            state.istCards = istCards;
        })
        .addCase(fetchIstCardsFailure, (state) => {
            state.istCards = [];
        })
        .addCase(fetchPowerOfAttorney, (state) => {
            state.powerOfAttorneys = undefined;
        })
        .addCase(fetchPowerOfAttorneySuccess, (state, { payload: powerOfAttorneys }) => {
            state.powerOfAttorneys = powerOfAttorneys;
        })
        .addCase(fetchEBankingContracts, (state) => {
            state.eBankingContracts = undefined;
        })
        .addCase(fetchEBankingContractsSuccess, (state, { payload: eBankingContracts }) => {
            state.eBankingContracts = eBankingContracts;
        })
        .addCase(fetchAddresses, (state) => {
            state.addresses = undefined;
        })
        .addCase(fetchAddressesSuccess, (state, { payload: addresses }) => {
            state.addresses = addresses;
        })
        .addCase(fetchCommunicationEntries, (state) => {
            state.communicationEntries = undefined;
        })
        .addCase(fetchCommunicationEntriesSuccess, (state, { payload: communicationEntries }) => {
            state.communicationEntries = communicationEntries;
        });
});
